/**
 * The learner session as it exists in localStorage.
 *
 * A session is two keys: `jwtToken` and `userId`. The token is a Sanctum
 * personal access token minted by Greenhat\Containers\Auth\Services\AuthService,
 * and because mha-usa-core shares this app's database, APP_KEY and
 * personal_access_tokens table, it authorises requests to core as well.
 *
 * `userId` is required too, matching AUS: core's mint route is
 * /v1/users/{userId}/accesses/learn-portal, so a token alone cannot complete a
 * handoff. store/auth/index.js writes it from the auth-user fetch.
 *
 * Values are written through JSON.stringify in places, so an absent value can
 * reach storage as the literal text "null" or "undefined". Those read as absent
 * here, which is why callers should not hit localStorage directly.
 */

function storedValue (key) {
    const value = window.localStorage.getItem(key)

    if (!value || value === 'null' || value === 'undefined') {
        return null
    }

    return value
}

/**
 * Whether a learner session is present to hand over.
 *
 * Tests exactly what the handoff consumes, so a session is never claimed for a
 * value that cannot complete one.
 *
 * @returns {boolean}
 */
export function hasStoredSession () {
    return !! storedValue('jwtToken') && !! storedValue('userId')
}

export default { hasStoredSession }
